/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskDetailCallOutcome = typeof TaskDetailCallOutcome[keyof typeof TaskDetailCallOutcome] | null;


export const TaskDetailCallOutcome = {
  connected: 'connected',
  voicemail: 'voicemail',
  no_answer: 'no_answer',
  wrong_number: 'wrong_number',
  disconnected: 'disconnected',
  other: 'other',
} as const;
